import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const PATH_TEMPLATE = '/workflow-reports/creators/{creatorId}/court-calendar';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const getCourtCalendar = async ({
  creatorId,
  startDate,
  endDate,
  hearingType,
  attorney,
  judge,
  trustee,
  client,
  caseNumber,
  courtroomLocation,
  courtRoom,
  hasZoom,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/workflow-reports/creators/${creatorId}/court-calendar`, {
    attorney,
    caseNumber,
    client,
    courtRoom,
    courtroomLocation,
    endDate,
    hasZoom,
    hearingType,
    judge,
    startDate,
    trustee,
  });
  return response.data;
};

export default getCourtCalendar;
